<template>
    <div class="wrapper">
        <el-image class="top" style="width: 100%;"
            src="https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/img/01.png" fit="contain"
            alt="码路科技"></el-image>



        <div class="tabsbox">
            <el-tabs class="eltabs" tab-position="top" :stretch="true">
                <el-tab-pane label="小程序&H5">
                    <div class="title">小程序&H5</div>
                    <div class="tabs">
                        <div class="tab" @click="activeTab(0)" :class="value == 0 ? 'active' : ''">全部</div>
                        <div class="tab" v-for="(item, index) in options" :class="value == item.value ? 'active' : ''"
                            :key="index" @click="activeTab(item.value)">
                            {{ item.label }}
                        </div>
                    </div>
                    <el-empty v-if="list.length == 0" description="没有找到哦..."></el-empty>
                    <div class="data-list">
                        <template v-for="(item, index) in list">
                            <div class="data-item">
                                <div style="width: 300px;height: 620px;display: flex;align-items: center;">
                                    <el-image style="width: 300px" lazy :src="item.img" fit="fill"></el-image>
                                </div>
                                <div class="item-right">
                                    <div class="item-right-title">{{ item.name }}</div>
                                    <div class="item-right-content u-line-2">
                                        {{ item.content }}
                                    </div>
                                    <div class="item-right-qrCode">
                                        <el-image class="image" style="width: 150px" :src="item.qr_code"
                                            fit="contain"></el-image>
                                        <div class="item-right-qrCode-text">扫一扫 试玩一下~</div>
                                        <div class="item-right-qrCode-text" style="margin-top: 50px;"
                                            v-if="item.iflogo">
                                            <img src="static/logo2.png" alt="" srcset="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="小游戏">
                    <div class="title">小游戏</div>
                    <el-empty v-if="gamelist.length == 0" description="没有找到哦..."></el-empty>
                    <div class="data-list" style="justify-content: center;margin-top: -50px;">
                        <template v-for="(item, index) in gamelist">
                            <div class="data-item" style="flex:none;padding-right: 80px;padding-left: 80px;">
                                <div style="width: 300px;height: 620px;display: flex;align-items: center;">
                                    <video preload="none" style="max-width: 600px;max-height: 600px;" :src="item.src"
                                        :poster="item.img" controls></video>
                                </div>
                                <div class="item-right" style="margin-left: 100px;">
                                    <div class="item-right-title">{{ item.name }}</div>
                                    <div
                                        style="display: flex;height: 90%; justify-content: center; align-items: center;">
                                        <div>
                                            <div class="item-right-qrCode">
                                                <el-image class="image" style="width: 150px" :src="item.qr_code"
                                                    fit="contain"></el-image>

                                            </div>
                                            <div class="item-right-qrCode-text">扫一扫 试玩一下~</div>
                                            <div class="item-right-qrCode-text" style="margin-top: 50px;"
                                                v-if="item.iflogo">
                                                <img src="static/logo2.png" alt="" srcset="">
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </template>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="官网">
                    <div class="title">官网</div>
                    <el-empty v-if="pclist.length == 0" description="没有找到哦..."></el-empty>
                    <div class="data-list" style="margin-top: -50px;">
                        <template v-for="(item, index) in pclist">
                            <div style="width: 100%;">
                                <div class="data-item" style="display: block;margin:0 0 40px 0;">
                                    <div class="item-right" style="width: 100%;">
                                        <div class="item-right-title">{{ item.name }}</div>
                                    </div>
                                    <div style="width: 100%;text-align: center;margin-top: 30px;">
                                        <el-image style="width: 100%" lazy :src="item.img" fit="fill"></el-image>
                                        <el-link type="danger" target="_blank" :href="item.url"
                                            style="margin-top: 20px;">点击前往</el-link>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="系统定制">
                    <div class="title">系统定制</div>
                    <el-empty v-if="systemlist.length == 0" description="没有找到哦..."></el-empty>
                    <div class="data-list" style="margin-top: -50px;">
                        <template v-for="(item, index) in systemlist">
                            <div style="width: 100%;">
                                <div class="data-item" style="display: block;margin:0 0 40px 0;">
                                    <div class="item-right" style="width: 100%;">
                                        <div class="item-right-title">{{ item.name }}</div>
                                    </div>
                                    <div style="width: 100%;text-align: center;margin-top: 30px;">
                                        <el-image style="width: 100%" lazy :src="item.img" fit="fill"></el-image>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </div>


    </div>
</template>

<script>
import imgurl from "../../static/wxzhifu.png";
export default {
    name: "index",
    data() {
        return {
            wxsrc: imgurl,
            dialogTableVisible: false,
            list: [],
            all_list: [],
            input: "",
            value: "",
            options: [],
            gamelist: [],
            pclist: [],
            systemlist: [],
            dataurl: 'https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/data.json?v=121'
            // dataurl: 'static/data.json'
        };
    },
    onload(e) {
        console.log(e);
    },
    mounted() {
        var url = window.location.href;             //获取当前url
        var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var cs = dz_url.split('?')[1];                 //获取?之后的参数字符串
        if (cs) {
            var cs_arr = cs.split('&');
            var cs = {};
            for (var i = 0; i < cs_arr.length; i++) {         //遍历数组，拿到json对象
                cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
            }
            if (cs.iflogo == 'true') {
                this.dataurl = "https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/data2.json?v=121"
            }
        }
        this.$http({
            method: "get",
            url: this.dataurl,
            // url: "static/data.json",
        })
            .then((res) => {
                this.options = res.data.type.map((type) => {
                    return {
                        label: type.name,
                        value: type.id,
                        Pinyin: type.Pinyin,
                    };
                });
                this.gamelist = res.data.gamelist
                this.list = res.data.list;
                this.pclist = res.data.pclist
                this.systemlist = res.data.systemlist
                this.all_list = res.data.list;
            })
            .catch((err) => {
                console.log(err);
            });
    },
    methods: {
        gmmb() {
            this.dialogTableVisible = true
        },
        activeTab(value) {
            this.value = value
            this.input = "";
            if (value == 0) {
                this.list = this.all_list
                return;
            }
            this.list = this.all_list.filter((item) => {
                return item.type_id == value;
            });
            console.log(value);
            console.log(value);
        },
        search() {
            this.value = ""
            let value = this.input;
            this.list = this.all_list.filter((item) => {
                return (
                    item.name.indexOf(value) != -1 || item.Pinyin.indexOf(value) != -1
                );
            });
        },
    },
};
</script>

<style lang="scss">
@import "../assets/common.scss";

.data-list1 {
    margin-bottom: 20px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-color: #262626;
    padding: 20px;
    padding-left: 30px;
    border-radius: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-right: 20px;
}

.tabsbox {
    width: 100%;

    .eltabs {
        width: 100%;

        .el-tabs__item {
            height: 100px;
            line-height: 100px;
            font-size: 25px;
            color: #fff
        }

        .el-tabs__item.is-active {
            color: #409EFF !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue